import type { VoidComponent } from "solid-js";

interface Props {
	size?: number;
}

const Spinner: VoidComponent<Props> = (props) => (
	<svg
		width={props.size ?? 24}
		height={props.size ?? 24}
		viewBox="0 0 24 24"
		fill="none"
		aria-hidden="true"
	>
		<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />

		<g class="animate-spin" transform-origin="12 12">
			<path
				class="animate-[spin_1s_var(--ease-in-out-sine)_infinite]"
				transform-origin="12 12"
				fill="none"
				stroke="currentColor"
				stroke-width="2"
				stroke-linecap="round"
				d="M12 2a10 10 0 0 1 10 10"
			/>
		</g>
	</svg>
);

export { Spinner };
